module.exports = __webpack_public_path__ + "static/media/Frame.ac64bea0.png";